import { PDFRequest } from "@/shared/model/360/pdf-request.model";
import { Client } from "@/shared/model/client.model";
import { IMultipleSend } from "@/shared/model/global/dashboard/multiple-send";
import { IInviteToGame } from "@/shared/model/global/invite-to-game.model";
import axios from "axios";

const baseApiUrl = "api/360-dashboard";

export default class Dashboard360Service {
  public invite(entity: IInviteToGame): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/invite`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  // renvoi une invitation initiale
  public remind(entity: IInviteToGame): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/remind`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public getRapport(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/get-rapport/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public generatePdf(pdfRequest: PDFRequest): Promise<string> {
    return new Promise<string>(function (resolve, reject) {
      axios
        .post(`${baseApiUrl}/generate-pdf`, pdfRequest)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public checkConformityPoint(entity: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/check-conformity-point`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public sendMultiple(entity: IMultipleSend): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/send-multiple`, entity)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
